module.exports = __webpack_public_path__ + "771610bd.svg";